import PropTypes from 'prop-types'
import { Avatar, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from '@mui/material'
import moment from 'moment'
import 'moment/locale/es'
import { Iconify } from '../../../../components/Iconify'
import { useNotificacionesContext } from '../../../../contexts/NotificacionesContext'

const NotificacionItem = ({ notif }) => {

    const { 
        id, no_titulo, no_contenido, no_icono, no_leida, created_at 
    } = notif

    const { updateLeerNotificacionHook } = useNotificacionesContext()

    moment.locale('es')

    const created = moment(created_at)
    const diff = created.diff(moment(), 'seconds')
    const dur = moment.duration(diff,'seconds').humanize(true)

    const onClick = async() => {
        if(!no_leida){
            await updateLeerNotificacionHook(id)
        }
    }

    return (
        <ListItemButton
            sx={{
                py: 1.5,
                px: 2.5,
                mt: '1px',
                ...(!no_leida && {
                    bgcolor: 'action.selected',
                }),
            }}
            onClick={onClick}
        >
            <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'background.neutral' }}>
                    <img alt={no_titulo} src={no_icono} />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                disableTypography
                primary={
                    <Typography variant="subtitle2">
                        {no_titulo}
                        <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                            &nbsp; {no_contenido}
                        </Typography>
                    </Typography>
                }
                secondary={
                    <Stack direction="row" sx={{ mt: 0.5, typography: 'caption', color: 'text.disabled' }}>
                        <Iconify icon="eva:clock-fill" width={16} sx={{ mr: 0.5 }} />
                        <Typography variant="caption">
                            {dur}
                        </Typography>
                    </Stack>
                }
            />
        </ListItemButton>
    )
}

NotificacionItem.propTypes = {
    notif: PropTypes.object
}

export { NotificacionItem }
